import { Component, OnDestroy, OnInit } from '@angular/core';
import { EntityCollectionService, EntityServices } from '@ngrx/data';
import { select, Store } from '@ngrx/store';
import clone from 'just-clone';
import moment from 'moment';
import { combineLatest, Observable, ReplaySubject } from 'rxjs';
import { filter, map, startWith, take, takeWhile, tap } from 'rxjs/operators';
import * as fromDataServices from '../../../data-services';
import * as fromShared from '../../../shared';
import { uniqBy } from '../../../shared';
import { LoggingService } from '../../../shared/services/logging';
import * as fromUser from '../../../user-info';
@Component({
    selector: 'ef-invoice-register-container',
    templateUrl: './invoice-register-container.component.html',
    styleUrls: ['./invoice-register-container.component.scss'],
    standalone: false
})
export class InvoiceRegisterContainerComponent implements OnInit, OnDestroy {
    InvoiceRegisterModelDS: EntityCollectionService<fromDataServices.InvoiceRegister.InvoiceRegisterModel>;
    InvoiceRegisterModel$: Observable<
        fromDataServices.InvoiceRegister.InvoiceRegisterModel[]
    >;
    contractsSelectItems$: Observable<fromShared.SelectItem[]>;
    process$: Observable<fromShared.Process>;
    userInfo$: Observable<fromUser.IUserInfo>;
    SelectStartDate = new ReplaySubject<Date>(1);
    SelectEndDate = new ReplaySubject<Date>(1);
    SelectedContractsSubject = new ReplaySubject<string[]>(1);
    FilterInvoiceNumberSubject = new ReplaySubject<string>(1);
    private active = true;
    constructor(
        private log: LoggingService,
        private store: Store,
        public entityServices: EntityServices
    ) {
        this.log.verbose({ type: 'InvoiceRegisterContainerComponent::' });
        this.InvoiceRegisterModelDS =
            entityServices.getEntityCollectionService<fromDataServices.InvoiceRegister.InvoiceRegisterModel>(
                fromDataServices.InvoiceRegister.entityName
            );
    }
    ngOnInit(): void {
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));
        this.userInfo$ = this.store.pipe(select(fromUser.getUserInfo));
        this.InvoiceRegisterModelDS.clearCache();
        // this.InvoiceRegisterModelDS.getAll();
        this.InvoiceRegisterModel$ = this.InvoiceRegisterModelDS.entities$.pipe(
            map(items => [...clone(items)]),
            map(items =>
                items.map(item => ({
                    ...item,
                    groupIndex: `${item.FullName}-${item.InvoiceNbr}`
                }))
            )
        );
        this.contractsSelectItems$ = this.InvoiceRegisterModelDS.entities$.pipe(
            map(items =>
                items.map(item => ({
                    label: item.FullName,
                    value: item.listid
                }))
            ),
            map(items => uniqBy(items, x => x.value)),
            map(
                items =>
                    (items = items.sort((a, b) =>
                        a.label.localeCompare(b.label, 'en', { numeric: true })
                    ))
            )
        );
        this.userInfo$.pipe(take(1)).subscribe(userInfo => {
            combineLatest([this.SelectStartDate, this.SelectEndDate])
                .pipe(
                    startWith([
                        userInfo.LastInvoiceStart,
                        userInfo.LastInvoiceEnd
                    ]),
                    takeWhile(() => this.active),
                    tap(([startDate, endDate]) =>
                        this.log.verbose({
                            type: 'InvoiceRegisterContainerComponent:StartDate,EndDate',
                            startDate,
                            endDate
                        })
                    ),
                    filter(
                        ([startDate, endDate]) =>
                            moment.isDate(startDate) && moment.isDate(endDate)
                    )
                )
                .subscribe(([startDate, endDate]) => {
                    this.InvoiceRegisterModelDS.clearCache();
                    this.InvoiceRegisterModelDS.getWithQuery({
                        startDate: moment(startDate).format('YYYY-MM-DD'),
                        endDate: moment(endDate).format('YYYY-MM-DD')
                    });
                });
        });
    }
    ngOnDestroy(): void {
        this.active = false;
    }
}
